import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

const validationSchema = () =>
  Yup.object().shape({
    contact_email: Yup.string().test(
      "test-email",
      "Please enter a valid email address",
      (value) => isEmail(value || "")
    ),
    contact_name: Yup.string()
      .required("Please enter your full name")
      .matches(/\w+(\s+\w+)+/, {
        message: "Please enter your first and last name",
      }),
    contact_phone_num: Yup.string()
      .matches(/^[\d\-+(). ]{10,20}$/, {
        message: "Please enter a valid phone number",
      })
      .required("Please enter a valid phone number"),
    files: Yup.mixed().test("fileType", "Unsupported file format", (files) =>
      files.every((f) => f.type.includes("image"))
    ),
    notes: Yup.string().required("Please specify the details of the repair"),
    repairItems: Yup.array().required("Please select an item to repair").min(1),
    rma_reason: Yup.string().required("Please select a reason for the repair"),
  })

export default validationSchema
